import { render, staticRenderFns } from "./Cake.vue?vue&type=template&id=d09472f6&scoped=true&"
import script from "./Cake.vue?vue&type=script&lang=js&"
export * from "./Cake.vue?vue&type=script&lang=js&"
import style0 from "./Cake.vue?vue&type=style&index=0&id=d09472f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09472f6",
  null
  
)

export default component.exports